const AWS = require('aws-sdk');

function AwsChangePasswordByAdmin(username, newPassword) {
  const userData = {
    Username: username,
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID,
    Password: newPassword,
    Permanent: true,
  };

  const cognitoSetPassword = new AWS.CognitoIdentityServiceProvider(
    {
      accessKeyId: process.env.VUE_APP_AWS_IAM_USER_KEY,
      secretAccessKey: process.env.VUE_APP_AWS_IAM_USER_SECRET,
      region: 'us-east-1',
    },
  );


  return new Promise((resolve, reject) => {
    cognitoSetPassword.adminSetUserPassword(userData, (err, data) => {
      if (err) {

        reject(err);
      } else {

        resolve('SUCCESS');
      }
    });
  });
}
export {
  AwsChangePasswordByAdmin as
  default,
};
